<template>
  <v-card-text>
    <v-form v-model="valid" lazy-validation @submit.prevent="submit" ref="form">
      <v-row>
        <v-col class="py-0" md="10" cols="12">
          <v-autocomplete
            :error-messages="errors.rota_id"
            :items="rotas"
            :loading="isloadingRota"
            :rules="rules.rota_id"
            :search-input.sync="searchAutoCompleteRota"
            clearable
            dense
            hide-no-data
            hide-selected
            item-text="nome"
            item-value="id"
            label="Rotas"
            outlined
            placeholder="Selecione uma rota"
            v-model="formData.rota_id"
          >
          </v-autocomplete>
        </v-col>
        <v-col class="py-0" md="2" cols="12">
          <v-btn type="submit" color="teal" dark depressed tile block>
            <v-icon left>mdi-plus</v-icon>
            Adicionar
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-divider class="mb-3"></v-divider>
    <VeiculoRotaTable />
  </v-card-text>
</template>

<script>
import veiculoHttp from '@/services/http/resources/frota/veiculoHttp';
import toastMessage from '@/services/util/alertService';
import { required } from '@/services/util/validate';
import { mapActions, mapState } from 'vuex';
import VeiculoRotaTable from '@/views/private/frota/veiculo/tables/TableRota.vue';

export default {
  name: 'TabRota',
  components: { VeiculoRotaTable },
  data: () => ({
    valid: true,
    rotas: [],
    formData: {
      rota_id: '',
    },
    formDataDefault: {
      rota_id: '',
    },
    rules: {
      rota_id: [required],
    },
    errors: {
      rota_id: [],
    },
    isloadingSubmit: false,
    isloadingRota: false,
    searchAutoCompleteRota: '',
  }),
  created() {
    this.loadRotas();
  },
  computed: {
    ...mapState('veiculo', ['data']),
    listRotas() {
      return this.data.rotas.length ? this.data.rotas : [];
    },
  },
  methods: {
    ...mapActions('veiculo', ['attachRota']),
    submit() {
      if (this.$refs.form.validate()) {
        if (this.checkItemExist()) {
          this.isloadingSubmit = true;
          this.attachRota(this.getFormData())
            .then(() => {
              toastMessage.successSave('Rota adicionado com sucesso');
              this.closeDialog();
            })
            .catch(({ response }) => {
              if (response.status === 422) {
                const { errors } = response.data;
                Object.entries(errors).forEach(([index, value]) => {
                  this.errors[index].push(value.toString());
                  toastMessage.errorValidation();
                });
              } else {
                toastMessage.errorSave('Erro ao adicionar rota');
              }
            })
            .finally(() => {
              this.isloadingSubmit = false;
            });
        } else {
          toastMessage.errorSave('Rota já existente para o veículo');
        }
      }
    },
    loadRotas() {
      this.isloadingRota = true;
      veiculoHttp
        .listRotas(this.data.id)
        .then(({ data: { data } }) => {
          this.rotas = data;
        })
        .catch(() => toastMessage.errorLoading('Erro ao carregar Rotas'))
        .finally(() => {
          this.isloadingRota = false;
        });
    },
    resetValidation() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    closeDialog() {
      setTimeout(() => {
        Object.entries(this.formDataDefault).forEach(([key]) => {
          this.formData[key] = this.formDataDefault[key];
        });
        this.resetValidation();
      }, 300);
    },
    getFormData() {
      if (this.checkItemExist()) {
        return {
          id: this.data.id,
          rota: this.formData.rota_id,
        };
      }
      return {};
    },
    checkItemExist() {
      const item = this.listRotas.findIndex((i) => i.id === this.formData.rota_id);
      return !(item > -1);
    },
  },
  watch: {
    'formData.rota_id': function () {
      this.errors.rota_id = [];
    },
  },
};
</script>
